import { Injectable } from '@angular/core';
import { GroupSubMenuDto, GroupSubMenu, GroupSubMenuPayload } from '../../models/system-settings/group-sub-menus.model';

@Injectable({
  providedIn: 'root',
})
export class MapperGroupSubMenusService {
  // ================= Normal Functions =================

  constructor() { }

  /**
   * Maps a single GroupSubMenuDto to GroupSubMenu model.
   * @param dto GroupSubMenuDto from API
   */
  mapGroupSubMenuFromDto(dto: GroupSubMenuDto): GroupSubMenu {
    return {
      id: dto.id,
      name: dto.name || '',
      enable: dto.enable ?? false,
      groupMenuId: dto.groupMenuId || 0,
      groupMenuName: dto.groupMenuName || '',
      number: dto.number || 0,
      icon: dto.icon || '',
      createDate: dto.create_date ? new Date(dto.create_date) : null,
      writeDate: dto.write_date ? new Date(dto.write_date) : null,
    };
  }

  /**
   * Maps a single GroupSubMenu model to GroupSubMenuDto payload. (Deprecated: Use mapGroupSubMenuToPayload instead for POST/PUT)
   * @param model GroupSubMenu model from UI
   */
  mapGroupSubMenuToDto(model: GroupSubMenu): GroupSubMenuDto {
    return {
      id: model.id,
      name: model.name,
      enable: model.enable,
      groupMenuId: model.groupMenuId,
      groupMenuName: model.groupMenuName,
      number: model.number,
      icon: model.icon,
      create_date: model.createDate ? model.createDate.toISOString() : null,
      write_date: model.writeDate ? model.writeDate.toISOString() : null,
    };
  }

  /**
   * Maps a GroupSubMenu model to the payload format required by insertGroupSubMenu and updateGroupSubMenu APIs.
   * @param model GroupSubMenu model from UI
   * @param userId ID of the user performing the action
   * @param menuId ID of the menu page where the action occurs
   */
  mapGroupSubMenuToPayload(model: GroupSubMenu, userId: number, menuId: number): GroupSubMenuPayload {
    return {
      id: model.id,
      name: model.name,
      enable: model.enable,
      groupMenuId: model.groupMenuId,
      number: model.number,
      icon: model.icon,
      userId: userId,
      menuId: menuId
    };
  }
}
